import script from "./Prism.vue?vue&type=script&lang=ts&setup=true"
export * from "./Prism.vue?vue&type=script&lang=ts&setup=true"

import "./Prism.vue?vue&type=style&index=0&id=9bb48152&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bb48152"]])

export default __exports__